/**
 * CSV modifications
 **/

define(function(require, exports, module) {
    'use strict';

    module.exports = {

        /**
         * Convert string date (format: yyyy-mm-dd) to UNIX timestamp. Also parse relatively date to current date such as (+9w, -10y, today)
         * @param dateStr
         * @returns {number|NaN}
         */
        parseStringDateToUnixFormat: function(dateStr) {
            if (dateStr === 'today') {
                return Date.now();
            }

            var dateISORegexp = /^(\d{4})[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/; // ISO format yyyy-mm-dd
            var isMatchedISOFormat = dateISORegexp.test(dateStr);

            if (isMatchedISOFormat) {
                return Date.parse(dateStr);
            }
            var periodFormatRegexp = /^([+|-]{1}\d+)([dwmy])$/; // for catch +/-[number]d/w/m/y
            var periodArr = dateStr.match(periodFormatRegexp);

            if (periodArr) {
                var factor = Number(periodArr[1]);
                var date = new Date();
                var y = date.getFullYear();
                var m = date.getMonth();
                var d = date.getDate();

                switch (periodArr[2]) {
                    case 'm':
                        m += factor;
                        break;
                    case 'd':
                        d += factor;
                        break;
                    case 'w':
                        d += 7 * factor;
                        break;
                    case 'y':
                        y += factor;
                        break;
                    default:
                        return NaN;
                }

                return new Date(y, m, d).getTime();
            }

            return NaN;
        },

        getStartOfTheDay: (date = new Date()) => {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);

            return date;
        },

        getEndOfTheDay: (date = new Date()) => {
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            date.setMilliseconds(999);

            return date;
        }
    };
});
